export function moneyNumber(value: string | number): string {
  return Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatMoney(value: string | number | null | undefined, currency = "TRY"): string {
  if (value === null || value === undefined || value === "") return "Tutar yok";
  try {
    return Number(value).toLocaleString("en-US", {
      style: "currency", currency: currency || "TRY", currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  } catch {
    return `${moneyNumber(value)} ${currency}`.trim();
  }
}

// Money inputs follow the displayed format. A comma is a thousands separator;
// incomplete/ambiguous or excess-precision values must not be silently changed.
export function parseMoneyInput(value: string): string | null {
  const trimmed = value.trim();
  if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(trimmed)) return null;
  const number = Number(trimmed.replaceAll(",", ""));
  return Number.isFinite(number) && number >= 0 && number < 1e14 ? number.toFixed(2) : null;
}

export function formatMoneyInput(value: string, editing = false): string {
  if (!value) return "";
  if (value.includes(",") && parseMoneyInput(value) === null) return value;
  const plain = value.replaceAll(",", "");
  if (!/^\d*(\.\d{0,2})?$/.test(plain)) return value;
  const [whole, fraction] = plain.split(".");
  const grouped = (whole || "0").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return grouped + (editing
    ? fraction === undefined ? "" : `.${fraction}`
    : `.${(fraction || "").padEnd(2, "0")}`);
}

export function formatMoneyText(text: string | undefined): string {
  return (text || "").replace(/(?<![\d.,])(-?(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?)\s+TL\b/g, (_, amount: string) => `${moneyNumber(amount.replaceAll(",", ""))} TL`);
}
